import React from 'react';
import unifiedDataPlatform from '../../../../images/main/unified-data-platform.png';
import GradientBackground from '../../../../shared/components/GradientBackground';
import './index.scss';

/* eslint-disable */
const SuperchargedCommerceSection = ({ isMobileView, targetRef }) => {
    const imageSRC = !isMobileView ? unifiedDataPlatform : unifiedDataPlatform;

    return (
        <div className='klickly-supercharged-2-wrapper' ref={targetRef}>
            <GradientBackground gradientType='orange' direction='left' />
            <div className='klickly-supercharged-2'>
                <div className='klickly-supercharged-2__content'>
                    <div className='klickly-supercharged-2__left'>
                        <div className='klickly-supercharged-2__head'>Unified data platform</div>
                        <div className='klickly-supercharged-2__title'>
                            A fully integrated <br/>
                            suite of real-time, <br/>
                            evergreen data to <br/>
                            help brands compete
                        </div>
                        <div className='klickly-supercharged-2__subtitle'>
                            Our proprietary, full-funnel consumer data engine leverages AI and billions of events, <br/>
                            mapped to millions of consumers, to unlock commerce insights and revenue for brands.
                        </div>
                    </div>
                    <div className='klickly-supercharged-2__right'>
                        <img src={imageSRC} className='klickly-supercharged-2__image' alt='Data-driven distributed commerce' />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SuperchargedCommerceSection;
